import React from 'react';
import { GiWheat } from 'react-icons/gi';
import { MdFolder, MdPlace } from 'react-icons/md';

const StatsPanel = ({ crops, translations }) => {
  const categories = new Set(crops.map(c => c.category)).size;
  const regions = new Set(crops.flatMap(c => c.region.split(',').map(r => r.trim()))).size;
  const totalCrops = crops.length;

  const stats = [
    { label: translations.totalCrops, value: totalCrops, icon: GiWheat },
    { label: translations.categories, value: categories, icon: MdFolder },
    { label: translations.regions, value: regions, icon: MdPlace },
  ];

  return (
    <div className="mb-8 grid grid-cols-3 gap-3 md:gap-6">
      {stats.map(({ label, value, icon: Icon }) => (
        <div
          key={label}
          className="flex items-center justify-between gap-3 bg-white border border-slate-200 rounded-xl p-4 md:p-5 transition-colors hover:border-slate-300"
        >
          <div className="min-w-0">
            <p className="text-[11px] md:text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1 truncate">
              {label}
            </p>
            <p className="text-2xl md:text-4xl font-bold text-emerald-700 leading-none">{value}</p>
          </div>
          <div className="shrink-0 w-9 h-9 md:w-12 md:h-12 rounded-lg bg-emerald-50 flex items-center justify-center">
            <Icon className="w-5 h-5 md:w-6 md:h-6 text-emerald-600" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsPanel;
